"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isExternal = isExternal;
exports.validUsername = validUsername;
exports.validURL = validURL;
exports.validLowerCase = validLowerCase;
exports.validUpperCase = validUpperCase;
exports.validAlphabets = validAlphabets;
exports.validEmail = validEmail;
exports.isString = isString;
exports.isArray = isArray;
exports.validPwd = validPwd;
exports.validPhone = validPhone;

require("core-js/modules/es6.regexp.to-string");

/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validUsername(str) {
  var valid_map = ['admin', 'editor'];
  return valid_map.indexOf(str.trim()) >= 0;
}
/**
 * @param {string} url
 * @returns {Boolean}
 */


function validURL(url) {
  var reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validLowerCase(str) {
  var reg = /^[a-z]+$/;
  return reg.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validUpperCase(str) {
  var reg = /^[A-Z]+$/;
  return reg.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validAlphabets(str) {
  var reg = /^[A-Za-z]+$/;
  return reg.test(str);
}
/**
 * @param {string} email
 * @returns {Boolean}
 */


function validEmail(email) {
  var pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  return pattern.test(email);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true;
  }

  return false;
}
/**
 * @param {Array} arg
 * @returns {Boolean}
 */


function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]';
  }

  return Array.isArray(arg);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validPwd(str) {
  var pattern = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,21}$/;
  return pattern.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */


function validPhone(str, areacode) {
  var pattern = /^(\+?0?86\-?)?1[345789]\d{9}$/;

  switch (areacode) {
    case '86':
      pattern = /^(\+?0?86\-?)?1[345789]\d{9}$/;
      break;

    case '61':
      pattern = /^(\+?61|0)4\d{8}$/;
      break;

    case '1':
      pattern = /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/;
      break;

    case '...':
      pattern = /^(\+?\d?)\d{6,11}$/;
      break;

    default:
      pattern = /^(\+?\d?)\d{6,11}$/;
      break;
  }

  return pattern.test(str);
}